import React from "react";

const DatabaseContent = ({ htmlContent }) => {
  return (
    <div
      className="unscoped-content"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default DatabaseContent;
